/*
 * @Author: Gexiaolei gxiaolei@163.com
 * @Date: 2022-12-01 17:49:10
 * @LastEditors: Gexiaolei gxiaolei@163.com
 * @LastEditTime: 2022-12-02 16:38:50
 * @FilePath: /fe-coms/components/business/reassignment-dialog/i18n.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
export default {
    'zh-CN': {
      record: '转派记录',
      operatCons: '操作内容',
      operatType: '操作类型',
      operator: '操作人',
      operatTime: '操作时间'
    },
    'en': {
        record: 'Transfer record',
        operatCons: 'Operation content',
        operatType: 'Operation type',
        operator: 'Operator',
        operatTime: 'Operation time'
    },
    'jp': {
    }
  }
  